export default "__VITE_ASSET__CCe$c1Ib__"